import { render, staticRenderFns } from "./ReferralsTable.vue?vue&type=template&id=79a4585a&scoped=true"
import script from "./ReferralsTable.vue?vue&type=script&lang=js"
export * from "./ReferralsTable.vue?vue&type=script&lang=js"
import style0 from "./ReferralsTable.vue?vue&type=style&index=0&id=79a4585a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a4585a",
  null
  
)

export default component.exports